import { forEach, map } from 'lodash'
import { IDocsInternosCV, IModelDocInterno } from 'src/model/candidato-api'
import { IGrupoDoc, ITipoDoc, TiposDocEstadosStore } from './tiposStore'

export type TTipoDocCv = {
  t: ITipoDoc
  vacio: boolean
  grupo: TGrupoDocCv
  docs: IModelDocInterno[]
}

export type TGrupoDocCv = {
  g: IGrupoDoc
  vacio: boolean
  list: TTipoDocCv[]
}

export class DocsCV {
  hayDocs = false
  hayTipos = false

  docsList: IModelDocInterno[]

  gruposDocCv: TGrupoDocCv[]
  tiposDocCv: { [tipo: string]: TTipoDocCv }

  updateDocs(docs: IDocsInternosCV) {
    this.docsList = docs.list

    this.hayDocs = true

    if (this.hayTipos) this._clasificaDocs()
  }

  private _clasificaDocs() {
    // limpiar todos los tipos
    forEach(this.tiposDocCv, (t) => {
      t.docs = []
      t.vacio = true
    })

    forEach(this.gruposDocCv, (g) => (g.vacio = true))

    // para todos los documentos, clasificar donde toca
    forEach(this.docsList, (doc) => {
      this._clasificaDoc(doc)
    })
  }

  updateTipos(tipos: TiposDocEstadosStore) {
    this.hayTipos = true

    this.tiposDocCv = {}
    this.gruposDocCv = map(tipos.gruposDocList(), (g) => {
      var grupo: TGrupoDocCv = {
        g,
        vacio: true,
        list: [],
      }

      grupo.list = this._tiposParaGrupo(grupo, g)

      return grupo
    })

    if (this.hayDocs) this._clasificaDocs()
  }
  private _tiposParaGrupo(grupo: TGrupoDocCv, g: IGrupoDoc): TTipoDocCv[] {
    return map(g.list, (t) => {
      var tipo: TTipoDocCv = {
        t,
        vacio: true,
        grupo,
        docs: [],
      }

      this.tiposDocCv[t.tipo] = tipo

      return tipo
    })
  }

  nuevoDoc(item: IModelDocInterno) {
    this.docsList.unshift(item)

    if (this.hayDocs && this.hayTipos) this._clasificaDoc(item, true)
  }

  private _clasificaDoc(doc: IModelDocInterno, esnuevo = false) {
    var t = this.tiposDocCv[doc.tipo]

    if (!t) {
      console.error('Tipo no encontrado clasificando documento')
      return
    }

    if (esnuevo) t.docs.unshift(doc)
    else t.docs.push(doc)

    t.vacio = false
    t.grupo.vacio = false
  }

  quitarDocDeGrupo(grupo: TGrupoDocCv, docBorrado: IModelDocInterno) {
    // en cada tipo, buscar si está el documento
    grupo.list.forEach((ttipo) => {
      let existe = ttipo.docs.findIndex((doc) => doc.iddocint === docBorrado.iddocint)

      if (existe > -1) ttipo.docs.splice(existe, 1)

      ttipo.vacio = !ttipo.docs.length
    })
  }
}
